import { twMerge } from 'tailwind-merge';
import React from 'react';

interface Props {
    className?: string;
    children: string | number;
}

const Notification = ({ className, children }: Props) => (
    <span
        dir="auto"
        className={twMerge(
            'bg-red text-2xs absolute end-0 top-0 z-[1] -mt-1 flex size-5 items-center justify-center rounded-full text-white dark:text-black',
            className,
        )}
    >
        {children}
    </span>
);

export default Notification;
